import React, { memo, Suspense } from "react";
import styles from "./PreLogin.module.scss";
import { Outlet } from "react-router-dom";
import Loader from "@/components/Loader/Loader";
import TitleUpdater from "@/components/TitleUpdater/TitleUpdater";

const PreLogin = () => {
  return (
    <div className={styles.mainContainer}>
      <TitleUpdater />
      <Suspense fallback={<Loader />}>
        <div className={styles.childrenContainer}>
          <Outlet />
        </div>
      </Suspense>
    </div>
  );
};

export default memo(PreLogin);
